var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNounEdit3556018(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.996,
    height: 23,
    viewBox: "0 0 22.996 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-edit-3556018",
    transform: "translate(-170.3 -100.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8840",
    "data-name": "Path 8840",
    d: "M272.611,100.8a4.262,4.262,0,0,0-3.035,1.258l-7.157,7.157a6.832,6.832,0,0,0-2.014,4.864V117.3h3.221a6.83,6.83,0,0,0,4.861-2.014l7.16-7.16a4.293,4.293,0,0,0-3.035-7.325Zm1.09,5.383-7.157,7.157a4.1,4.1,0,0,1-2.918,1.21h-.471v-.471a4.1,4.1,0,0,1,1.207-2.918l7.16-7.16a1.543,1.543,0,1,1,2.179,2.179Z",
    transform: "translate(-84.104)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8841",
    "data-name": "Path 8841",
    d: "M174.925,143.825H187.3a4.125,4.125,0,0,0,4.125-4.125v-5.5h-2.75v5.5a1.375,1.375,0,0,1-1.375,1.375H174.925a1.375,1.375,0,0,1-1.375-1.375V127.325a1.375,1.375,0,0,1,1.375-1.375h5.5V123.2h-5.5a4.125,4.125,0,0,0-4.125,4.125V139.7a4.125,4.125,0,0,0,4.125,4.125Z",
    transform: "translate(0 -21.026)",
    fill: "#5f5f5f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounEdit3556018);
export default __webpack_public_path__ + "static/media/noun-edit-3556018.659cc0c73e04b0c3b48e97f6d3c71414.svg";
export { ForwardRef as ReactComponent };